import type { Highlightable } from '@angular/cdk/a11y';
import type { EventEmitter, OutputEmitterRef } from '@angular/core';
import type { Observable } from 'rxjs';

export interface Selectable<T> extends Highlightable {
  readonly id: string;
  readonly onSelectionChange: EventEmitter<SelectionChangeEvent<T>> | OutputEmitterRef<SelectionChangeEvent<T>>;
  select(fromView: boolean): void;
  deselect(): void;
  isSelected(): boolean;
}

export interface SelectableItem<T> extends Selectable<SelectableItem<T>> {
  getValue(): T;
  getLabel(): string;
}

export class SelectionChangeEvent<T> {
  constructor(
    public source: T,
    public fromView: boolean = false) {
  }
}

export type ChangeEventOn<T> = Observable<SelectionChangeEvent<T>>;
